import { andonApi } from "./andon";

export const {
  useToggleHandRaiseMutation,
  useLazyGetAndonStateQuery,
  useGetAndonWorkstationsQuery,
  useLazyGetAndonWorkstationsQuery,
  useSendSupportBundleMutation
} = andonApi;
